import { render } from "./PrivacyStatement.vue?vue&type=template&id=31a1f48e&scoped=true&ts=true"
import script from "./PrivacyStatement.vue?vue&type=script&lang=ts"
export * from "./PrivacyStatement.vue?vue&type=script&lang=ts"

import "./PrivacyStatement.vue?vue&type=style&index=0&id=31a1f48e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a1f48e"]])

export default __exports__